/* eslint-disable max-lines */
import { IBusinessShoppingCenterSchema } from '../../../../../repositories/offer-card/entities/business_shopping_center/BusinessShoppingCenterSchema';
import { IFeatureItem, IOffer } from '../../../../../types/offerData';

export const createFeatureList = (
  offer: IOffer,
  businessShoppingCenter: IBusinessShoppingCenterSchema | null,
): IFeatureItem[] => {
  const featuresList: IFeatureItem[] = [];

  if (offer.building?.infrastructure?.hasCarWash || businessShoppingCenter?.infrastructure?.hasCarWash) {
    featuresList.push({
      theme: 'car-wash',
      name: 'Автомойка',
    });
  }

  if (offer.building?.infrastructure?.hasCarService || businessShoppingCenter?.infrastructure?.hasCarService) {
    featuresList.push({
      theme: 'car-service',
      name: 'Автосервис',
    });
  }

  if (offer.building?.infrastructure?.hasPharmacy || businessShoppingCenter?.infrastructure?.hasPharmacy) {
    featuresList.push({
      theme: 'pharmacy',
      name: 'Аптека',
    });
  }

  if (offer.building?.infrastructure?.hasAtm || businessShoppingCenter?.infrastructure?.hasAtm) {
    featuresList.push({
      theme: 'atm',
      name: 'Банкомат',
    });
  }

  if (offer.building?.infrastructure?.hasPool || businessShoppingCenter?.infrastructure?.hasPool) {
    featuresList.push({
      theme: 'pool',
      name: 'Бассейн',
    });
  }

  if (offer.building?.infrastructure?.hasBuffet || businessShoppingCenter?.infrastructure?.hasBuffet) {
    featuresList.push({
      theme: 'buffet',
      name: 'Буфет',
    });
  }

  if (
    offer.building?.infrastructure?.hasExhibitionAndWarehouseComplex ||
    businessShoppingCenter?.infrastructure?.hasExhibitionAndWarehouseComplex
  ) {
    featuresList.push({
      theme: 'exhibition-warehouse-complex',
      name: 'Выставочно-складской комплекс',
    });
  }

  if (offer.building?.infrastructure?.hasHotel || businessShoppingCenter?.infrastructure?.hasHotel) {
    featuresList.push({
      theme: 'hotel',
      name: 'Гостиница',
    });
  }

  if (offer.building?.infrastructure?.hasGameRoom || businessShoppingCenter?.infrastructure?.hasGameRoom) {
    featuresList.push({
      theme: 'game-room',
      name: 'Игровая комната',
    });
  }

  if (offer.building?.infrastructure?.hasCafe || businessShoppingCenter?.infrastructure?.hasCafe) {
    featuresList.push({
      theme: 'cafe',
      name: 'Кафе',
    });
  }

  if (offer.building?.infrastructure?.hasCinema || businessShoppingCenter?.infrastructure?.hasCinema) {
    featuresList.push({
      theme: 'cinema',
      name: 'Кинотеатр',
    });
  }

  if (offer.building?.infrastructure?.hasConferenceRoom || businessShoppingCenter?.infrastructure?.hasConferenceRoom) {
    featuresList.push({
      theme: 'conference-room',
      name: 'Конференц-зал',
    });
  }

  if (offer.building?.infrastructure?.hasMedicalCenter || businessShoppingCenter?.infrastructure?.hasMedicalCenter) {
    featuresList.push({
      theme: 'pharmacy',
      name: 'Медицинский центр',
    });
  }

  if (offer.building?.infrastructure?.hasMinimarket || businessShoppingCenter?.infrastructure?.hasMinimarket) {
    featuresList.push({
      theme: 'market',
      name: 'Минимаркет',
    });
  }

  if (offer.building?.infrastructure?.hasNotaryOffice || businessShoppingCenter?.infrastructure?.hasNotaryOffice) {
    featuresList.push({
      theme: 'notary-office',
      name: 'Нотариальная контора',
    });
  }

  if (offer.building?.infrastructure?.hasBankDepartment || businessShoppingCenter?.infrastructure?.hasBankDepartment) {
    featuresList.push({
      theme: 'bank-department',
      name: 'Отделение банка',
    });
  }

  if (offer.building?.infrastructure?.hasOfficeSpace || businessShoppingCenter?.infrastructure?.hasOfficeSpace) {
    featuresList.push({
      theme: 'office-space',
      name: 'Офисные помещения',
    });
  }

  if (offer.building?.infrastructure?.hasPark || businessShoppingCenter?.infrastructure?.hasPark) {
    featuresList.push({
      theme: 'park',
      name: 'Парк',
    });
  }

  if (offer.building?.infrastructure?.hasRestaurant || businessShoppingCenter?.infrastructure?.hasRestaurant) {
    featuresList.push({
      theme: 'cafe',
      name: 'Ресторан',
    });
  }

  if (offer.building?.infrastructure?.hasBeautyShop || businessShoppingCenter?.infrastructure?.hasBeautyShop) {
    featuresList.push({
      theme: 'beauty-shop',
      name: 'Салон красоты',
    });
  }

  if (offer.building?.infrastructure?.hasWarehouse || businessShoppingCenter?.infrastructure?.hasWarehouse) {
    featuresList.push({
      theme: 'warehouse',
      name: 'Складские помещения',
    });
  }

  if (offer.building?.infrastructure?.hasCanteen || businessShoppingCenter?.infrastructure?.hasCanteen) {
    featuresList.push({
      theme: 'cafe',
      name: 'Столовая',
    });
  }

  if (offer.building?.infrastructure?.hasSupermarket || businessShoppingCenter?.infrastructure?.hasSupermarket) {
    featuresList.push({
      theme: 'market',
      name: 'Супермаркет',
    });
  }

  if (offer.building?.infrastructure?.hasShoppingArea || businessShoppingCenter?.infrastructure?.hasShoppingArea) {
    featuresList.push({
      theme: 'market',
      name: 'Торговая зона',
    });
  }

  if (offer.building?.infrastructure?.hasFitnessCentre || businessShoppingCenter?.infrastructure?.hasFitnessCentre) {
    featuresList.push({
      theme: 'fitness-centre',
      name: 'Фитнес-центр',
    });
  }

  if (offer.building?.infrastructure?.hasStudio || businessShoppingCenter?.infrastructure?.hasStudio) {
    featuresList.push({
      theme: 'photo-studio',
      name: 'Фотосалон',
    });
  }

  if (offer.building?.infrastructure?.hasFoodCourt || businessShoppingCenter?.infrastructure?.hasFoodCourt) {
    featuresList.push({
      theme: 'cafe',
      name: 'Фуд-корт',
    });
  }

  if (
    offer.building?.infrastructure?.hasCentralReception ||
    businessShoppingCenter?.infrastructure?.hasCentralReception
  ) {
    featuresList.push({
      theme: 'central-reception',
      name: 'Центральная рецепция',
    });
  }

  if (offer.building?.infrastructure?.hasAutomaticGates) {
    featuresList.push({
      theme: 'automatic-gates',
      name: 'Автоматические ворота',
    });
  }

  if (offer.building?.infrastructure?.hasAquapark) {
    featuresList.push({
      theme: 'aquapark',
      name: 'Аквапарк',
    });
  }

  if (offer.building?.infrastructure?.hasClothesStudio) {
    featuresList.push({
      theme: 'clothes-studio',
      name: 'Ателье одежды',
    });
  }

  if (offer.building?.infrastructure?.hasBabySitting) {
    featuresList.push({
      theme: 'baby-sitting',
      name: 'Беби-ситинг',
    });
  }

  if (offer.building?.infrastructure?.hasBowling) {
    featuresList.push({
      theme: 'bowling',
      name: 'Боулинг',
    });
  }

  if (offer.building?.infrastructure?.hasVideoSurveillance) {
    featuresList.push({
      theme: 'video-surveillance',
      name: 'Видеонаблюдение',
    });
  }

  if (offer.building?.infrastructure?.hasEntryByPass) {
    featuresList.push({
      theme: 'entry-by-pass',
      name: 'Въезд по пропускам',
    });
  }

  if (offer.building?.infrastructure?.hasSlotMachines) {
    featuresList.push({
      theme: 'slot-machines',
      name: 'Игровые автоматы',
    });
  }

  if (offer.building?.infrastructure?.hasRink) {
    featuresList.push({
      theme: 'rink',
      name: 'Каток',
    });
  }

  if (offer.building?.infrastructure?.hasHourSecurity) {
    featuresList.push({
      theme: 'secure',
      name: 'Круглосуточная охрана',
    });
  }

  if (offer.building?.infrastructure?.hasBasement) {
    featuresList.push({
      theme: 'basement',
      name: 'Подвал/погреб',
    });
  }

  if (offer.building?.infrastructure?.hasInspectionPit) {
    featuresList.push({
      theme: 'inspection-pit',
      name: 'Смотровая яма',
    });
  }

  if (offer.building?.infrastructure?.hasTire) {
    featuresList.push({
      theme: 'tire',
      name: 'Шиномонтаж',
    });
  }

  return featuresList;
};
